import { useEffect, useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import prettier from "prettier/standalone";
import parserHtml from "prettier/parser-html";

export default function HtmlEditor({
  value = "",
  onChange,
  variables = [],
  height = 400,
  readOnly = false,
}) {
  const [code, setCode] = useState(value);

  useEffect(() => {
    setCode(value);
  }, [value]);

  const handleChange = (val) => {
    setCode(val);
    onChange?.(val);
  };

  const formatHtml = () => {
    if (!code) return;
    const formatted = prettier.format(code, {
      parser: "html",
      plugins: [parserHtml],
    });
    handleChange(formatted);
  };

  return (
    <div style={{ border: "1px solid #E2E8F0", borderRadius: 8 }}>
      <div
        style={{
          padding: "6px 10px",
          borderBottom: "1px solid #E2E8F0",
          background: "#F8FAFC",
          textAlign: "right",
        }}
      >
        {!readOnly && (
          <button
            type="button"
            onClick={formatHtml}
            style={{
              fontSize: 12,
              background: "transparent",
              border: "none",
              color: "#1677ff",
              cursor: "pointer",
            }}
          >
            Format HTML
          </button>
        )}
      </div>
      <CodeMirror
        value={code}
        height={`${height}px`}
        extensions={[html()]}
        onChange={handleChange}
        editable={!readOnly}
      />
    </div>
  );
}
